import { Card, CardContent, Typography, Chip, Stack } from "@mui/material";
import { Patient } from "../api/patients";
import PatientIdBadge from "./PatientIdBadge";

const SEX_LABELS: Record<string, string> = {
  male: "Мужской",
  female: "Женский",
};

const EDUCATION_LABELS: Record<string, string> = {
  incompleteSecondaryEducation: "Неполное среднее",
  secondaryEducation: "Среднее",
  incompleteHigherEducation: "Неполное высшее",
  higherEducation: "Высшее",
  academicDegree: "Учёная степень",
};

const LANGUAGE_LABELS: Record<string, string> = {
  KK: "Қазақша",
  RU: "Русский",
  EN: "English",
  ES: "Español",
};

interface Props {
  patient: Patient;
}

export default function PatientCard({ patient }: Props) {
  return (
    <Card>
      <CardContent>
        {patient.patient_id && <PatientIdBadge patientId={patient.patient_id} />}
        <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap", gap: 1 }}>
          {patient.sex && <Chip label={SEX_LABELS[patient.sex] || patient.sex} size="small" />}
          {patient.age != null && <Chip label={`${patient.age} лет`} size="small" />}
          {patient.education && (
            <Chip label={EDUCATION_LABELS[patient.education] || patient.education} size="small" />
          )}
          {patient.language && (
            <Chip label={LANGUAGE_LABELS[patient.language] || patient.language} size="small" />
          )}
        </Stack>
        {patient.diseases && patient.diseases.length > 0 && (
          <Stack direction="row" spacing={1} sx={{ mt: 1.5, flexWrap: "wrap", gap: 1 }}>
            {patient.diseases.map((disease) => (
              <Chip key={disease} label={disease} size="small" color="warning" variant="outlined" />
            ))}
          </Stack>
        )}
        {patient.free_notes && (
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
            {patient.free_notes}
          </Typography>
        )}
        {patient.created_by_user && (
          <Typography variant="caption" sx={{ color: "text.secondary", mt: 1, display: "block" }}>
            Создал: {patient.created_by_user.email}
          </Typography>
        )}
        {patient.created_at && (
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {new Date(patient.created_at).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Almaty" })}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
